import { LocalizationService, Localizer } from './localization.service';
export { LocalizationService, Localizer, };
export const l10n = new LocalizationService();
export function l10nTranslations(locale) {
    const l10n = new LocalizationService();
    return l10n.getLocalizer(locale);
}
